import { mapState } from 'vuex'

export default {
  data () {
    return {
      menu: null
    }
  },
  computed: {
    ...mapState(['user', 'menus', 'company']),
    isAdminMode () {
      return this.$route.name.startsWith('admin')
    },
    headerClass () {
      return `${this.$route.name === 'home' ? this.themeClasses('homeHeader') : this.themeClasses('header')}`
    },
    myMenu () {
      if (!this.isAdminMode) {
        return this.menus.user
      } else {
        if (this.user.level >= this.$utils.getLevel('system1')) {
          // console.log(this.menus.master)
          return [
            {
              menuName: '시스템 관리',
              menuType: 'master',
              route: {
                role: 'head-master'
              },
              children: [
                {
                  menuName: '고객사 관리',
                  route: {
                    name: 'adminCompany',
                    role: 'head-master'
                  }
                }
              ]
            }
          ]
        } else {
          const menus = this.menus.master.filter(row => {
            if (row.meta && row.meta.route && row.meta.route.role) {
              const { role } = row.meta.route
              if (this.user.level < this.$utils.getLevel(role)) {
                return false
              }
            }
            return true
          })

          if (this.user.level >= this.$utils.getLevel('master1')) {
            menus.push({
              menuName: '약관 관리',
              menuType: 'master',
              route: {
                name: 'adminMyTerms',
                role: 'master1'
              }
            })
          }

          if (this.user.level === this.$utils.getLevel('head-master')) {
            menus.push({
              menuName: '사이트 관리',
              menuType: 'master',
              route: {
                role: 'head-master'
              },
              children: [
                {
                  menuName: '사이트 설정',
                  route: {
                    name: 'adminMyCompany',
                    role: 'head-master'
                  }
                },
                {
                  menuName: '게시판 관리',
                  route: {
                    name: 'adminBoardMeta',
                    role: 'head-master'
                  }
                },
                {
                  menuName: '사용자 메뉴 관리',
                  route: {
                    name: 'adminUserMenu',
                    params: { menuType: 'user' },
                    role: 'head-master'
                  }
                },
                {
                  menuName: '관리자 메뉴 관리',
                  route: {
                    name: 'adminMasterMenu',
                    params: { menuType: 'master' },
                    role: 'head-master'
                  }
                },
                {
                  menuName: '디자인 포스트',
                  route: {
                    name: 'adminBoardList',
                    params: {
                      boardId: 'design'
                    },
                    role: 'head-master'
                  }
                },
                {
                  menuName: '이미지 갤러리',
                  route: {
                    name: 'adminResource',
                    role: 'head-master'
                  }
                }
              ]
            })
          }
          return menus
        }
      }
    }
  },
  methods: {
    menuOff () {
      this.menu = null
    },
    open (menu) {
      const { children = [] } = menu
      if (children.length > 0 && this.menu !== menu) {
        this.menu = menu
      } else {
        this.menu = null
      }
    },
    menuClick (menu) {
      if (menu.route && menu.route.name) {
        this.$router.push(menu.route)
      } else {
        if (this.selected !== menu) {
          this.selected = menu
        } else {
          this.selected = null
        }
        this.$emit('selected', menu)
      }
    }
    // go (menu) {
    //   console.log('menu', menu)
    //   const { boardId, boardSeq } = menu.meta.route || {}
    //   if (boardId === 'design') {
    //     this.$router.push({ name: 'designView', params: { boardId, seq: boardSeq } })
    //   } else if (boardId && boardSeq) {
    //     this.$router.push({ name: 'boardView', params: { boardId, seq: boardSeq } })
    //   } else if (boardId) {
    //     this.$router.push({ name: 'boardList', params: { boardId } })
    //   } else {
    //     this.$router.push({ name: 'home' })
    //   }
    // }
  }
}
